//angular imports
import { ChangeDetectionStrategy, Component } from "@angular/core";

//local imports
import { CatalogStatus } from "@app/catalog-common";

@Component({
    selector: "catalog-filters",
    templateUrl: "./catalog-filters.component.html",
    styleUrl: "./catalog-filters.component.scss",
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class CatalogFiltersComponent {
  CatalogFilterType: typeof CatalogStatus = CatalogStatus;
}
